import styled from 'styled-components';

import { LinkButton } from 'components/ui/Button';

import { colours } from 'themes/default';

import { serviceStatuses, extendedServiceStopStatuses } from 'types/timetableServices';

const statusColours = {
  [serviceStatuses.CANCELLED]: colours.Messaging.ErrorRed,
  [serviceStatuses.LIMITED_SERVICE]: colours.Messaging.ErrorRed,
  [serviceStatuses.SEATING_CHANGED]: colours.Messaging.ErrorRed
};

const stationStatusColours = {
  [extendedServiceStopStatuses.CANCELLED]: colours.Messaging.ErrorRed,
  [extendedServiceStopStatuses.EXPECTED]: colours.Messaging.WarningOrange,
  [extendedServiceStopStatuses.ARRIVED_LATE]: colours.Messaging.ErrorRed,
  [extendedServiceStopStatuses.DEPARTED_LATE]: colours.Messaging.ErrorRed
};

const stationStatusTextDecoration = {
  [extendedServiceStopStatuses.CANCELLED]: 'line-through'
};

export const StyledContainer = styled.div`
  max-width: 762px;
  min-width: 75%;
  margin: 0 auto;
  padding: 25px;
`;

export const StyledSearchBar = styled.div`
  align-items: center;
  background-color: ${colours.Shades.TintBlue10};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 16px;
  margin-bottom: 10px;
  padding: 10px;

  select,
  input {
    height: 40px;
  }
`;

export const StyledTrains = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTrain = styled.div`
  border: 1px solid ${colours.Greyscale.MistGrey};
  border-radius: 8px;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 9%);
  margin: 0 0 2rem 0;
  position: relative;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const StyledCarrier = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;
  font-weight: 600;
  background-color: ${colours.Shades.TintBlue10};
  border-bottom-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 8px 10px;
`;

export const StyledTrainInfo = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 2rem;
`;

export const StyledOverview = styled.div`
  align-items: center;
  color: ${colours.Greyscale.Charcoal};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 65%;
`;

export const StyledDirection = styled.div`
  min-width: 7rem;
`;

export const StyledTime = styled.p`
  color: ${({ status }) => stationStatusColours[status] || 'inherit'};
  font-size: 1.75rem;
  font-weight: bold;
  line-height: 2rem;
  margin: 0;
  text-decoration: ${({ status }) => stationStatusTextDecoration[status] || 'none'};
`;

export const StyledStation = styled.p`
  margin: 0;
  white-space: nowrap;
`;

export const StyledStatus = styled.p``;

export const StyledArrow = styled.div`
  background: ${colours.Greyscale.Charcoal};
  height: 1px;
  margin: 0 1rem;
  position: relative;
  width: calc(100% - 10.25rem);

  &::before {
    border: 3px solid transparent;
    border-left: 8px solid ${colours.Greyscale.Charcoal};
    content: '';
    display: block;
    position: absolute;
    top: -2.5px;
    right: -8px;
  }
`;

export const StyledTomorrowHeader = styled.div`
  margin: 16px 0;
`;

export const StyledMoreInformationHeader = styled.p`
  align-items: center;
  color: ${({ status }) => statusColours[status] || 'inherit'};
  display: flex;
  margin: 0;
`;

export const StyledMoreInformationContainer = styled.div`
  border-top: 1px solid ${({ visible }) => (visible ? colours.Greyscale.SilverGrey : 'transparent')};
  max-height: ${({ visible }) => (visible ? '1000px' : '0')};
  overflow: hidden;
  transition: all ease-in-out 0.25s;
`;

export const StyledMoreInformationContent = styled.div`
  display: flex;
  margin: 2rem;
`;

export const StyledDisruptionMessages = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 16px;

  > div:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;

export const StyledInputDate = styled.input.attrs({ type: 'date' })`
  appearance: none;
  background-color: ${colours.Greyscale.White};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  border-radius: 0.25rem;
  box-sizing: border-box;
  color: ${colours.Shades.BlueShade40};
  line-height: 18px;
  padding: 0 0.8em;
`;

export const NewsContainer = styled.div`
  margin-right: auto;
  width: 65%;
`;

export const StyledShowMoreInformation = styled(LinkButton).attrs({ icon: 'ChevronDown' })`
  color: inherit;
  font-weight: normal;

  // This is not very nice
  div {
    color: inherit;
  }
`;
